import { ILocation } from '../../services/location.service';
import { EmployeesService, IEmployeeSubscription, ITeam, LocationService, TeamService } from '../../services';
import { IShift, ShiftService } from '../../services/shifts.service';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";


class SubscriptionsItemController implements ng.IComponentController {
    private location: ILocation;
    private subscription: IEmployeeSubscription;
    private newSubscription: any;
    private onChange: any;
    private shift: IShift;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private TeamService: TeamService,
        private LocationService: LocationService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.getShift();

        if(this.$stateParams['id']){
            this.onChange({type: 'init', data: this.$stateParams['id'] });
        }
    } 
    
    public getShift = () => {
        this.ShiftService.customGet(this.$stateParams['id'] + '/withDistance').then((shift) => {
            this.shift = shift;
            if(this.shift.subscriptionsCount > 0){
                this.shift.subscribed = true;
                this.subscription = this.shift.mySubscription;
            } else {
                this.subscription = new IEmployeeSubscription();
                this.subscription.shiftId = this.shift.id;
            }
            this.getLocation();
        })
    }

    public getLocation() {
        this.LocationService.get(this.shift.teamLocationId).then((location) => {
            this.location = location;
        })
    }

    public signUp = () =>  {
        if (!this.subscription.id) {
            this.EmployeesService.postSubscription(this.subscription).then((result: any) => {
                this.shift.subscribed = true;
                this.onChange({type: 'update', data: this.$stateParams['id'] });
            });
        } else {
            this.EmployeesService.putSubscription(this.subscription).then((result: any) => {
                this.shift.subscribed = true;
                this.onChange({type: 'update', data: this.$stateParams['id'] });
            });
        }
    }

    public unsubscribe = () =>  {
        var subscriptionId = this.shift.mySubscription.id
        this.EmployeesService.customDelete('subscriptions/' + subscriptionId).then(() => {
            this.shift.subscribed = false;
            this.onChange({type: 'update', data: this.$stateParams['id'] });
        });
    }
    
}

export const subscriptionsItemComponent: ng.IComponentOptions = {
    bindings: {
        onChange: '&',
    },
    controller: SubscriptionsItemController,
    template: <string>require('./subscriptions.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/subscriptions.item.component.ts